import { Controller } from "react-hook-form";
import { FormLabel } from "../FormLabel";
import { FileInput } from "@/components";
import { FormErrorLabel } from "../FormErrorLabel";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui";
import { BadgeInfo } from "lucide-react";

const FormFileInput = ({
  name,
  label,
  control,
  error,
  isRequired,
  ...rest
}: any) => {
  return (
    <div className="relative flex flex-col items-start gap-1">
      {label && (
        <FormLabel>
          {label}{" "}
          {rest?.disabled ? (
            <></>
          ) : (
            <span className="text-red-700">{isRequired ? "*" : ""}</span>
          )}
          {rest?.info &&
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger className="mx-1" type="button">
                  <BadgeInfo className="h-3 w-3 stroke-yellow-600" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>{rest?.info}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          }
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <FileInput
              {...field}
              {...rest}
              setFile={field.onChange}
              file={field.value}
            />
          );
        }}
      />
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};

export default FormFileInput;
